module.exports = __webpack_public_path__ + "static/img/nutrena.fec81af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nutrena.png
// module id = 665
// module chunks = 1